__turbopack_context__.v({
  "className": "a8v0Jq_className",
  "variable": "a8v0Jq_variable",
});
